// @ts-ignore
import QQ from "/@/assets/qq.png";import Discord from "/@/assets/discord.svg";import QQChannel from "/@/assets/qq_channel.png";import KeyArt_landscape from "/@/assets/KeyArt_landscape.png";import Telegram from "/@/assets/telegram.png";import one_drive from "/@/assets/one_drive.png";import google_drive from "/@/assets/google_drive.png";import github from "/@/assets/github-mark-white.svg"
//import ClashCn from '/@/assets/Clash-CN.ttf';

const preloadImage =async (src: string) => {
    const img = new Image();
    img.src = src;
};
// const preloadFont = async(fontName: string, fontUrl: string) => {
//     const font = new FontFace(fontName, `url(${fontUrl})`);
//     try{
//         await font.load()
//         console.log(`${fontName} 字体已加载`);
//     }
//     catch (error){
//         console.error(`字体加载失败: ${error}`);
//     }
// };
// const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export async function preloadAll(){
    //await preloadFont('wenfeng-jnbbh', ClashCn);
    //console.log("已加载");
    await preloadImage(QQ);
    await preloadImage(QQChannel);
    await preloadImage(KeyArt_landscape);
    await preloadImage(Discord);
    await preloadImage(Telegram);
    await preloadImage(one_drive);
    await preloadImage(google_drive);
    await preloadImage(github);
}
export default {preloadAll}
